export default __webpack_public_path__ + "static/media/featured.2bf6b035.png";